import { render, staticRenderFns, recyclableRender, components } from "./vip-chapter-page.vue?vue&type=template&id=02098c78&scoped=true&"
var renderjs
import script from "./vip-chapter-page.vue?vue&type=script&lang=js&"
export * from "./vip-chapter-page.vue?vue&type=script&lang=js&"
import style0 from "./vip-chapter-page.vue?vue&type=style&index=0&id=02098c78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../Applications/HBuilderX.app/Contents/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02098c78",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/question-bank/vip-chapter-page.vue"
export default component.exports